/**
 * Inbox Page
 *
 * This is a placeholder component - the actual Chatwoot iframe is rendered
 * by PersistentChatwoot in MainLayout to keep it mounted across navigation.
 *
 * This component exists only to:
 * 1. Satisfy the router (so /inbox is a valid route)
 * 2. Provide a fallback if PersistentChatwoot hasn't mounted yet
 *
 * The PersistentChatwoot component shows/hides itself based on the route,
 * so this page renders nothing (the iframe is shown by the layout).
 */

export function InboxPage() {
  // PersistentChatwoot in MainLayout handles the actual iframe rendering
  // This component returns null since the layout takes care of everything
  return null;
}
